import { AdeptusCampaignType as a } from "../../constants/adeptus.js";
import * as e from "yup";
const i = e.object({
  display: e.object({
    action: e.string().default(""),
    summary: e.string().default(""),
    title: e.string().default("")
  }),
  id: e.string().default("0"),
  link: e.string().default(""),
  type: e.mixed().oneOf(Object.values(a)).default(a.NoCampaign)
}).from("metaKey", "display").from("campaignID", "id").from("campaignLink", "link").from("adeptusCampaignType", "type").noUnknown(!0), n = e.boolean().default(!1);
export {
  i as adeptusCampaignSchema,
  n as believeInviterSchema
};
//# sourceMappingURL=adeptusCampaign.js.map
